import React, { useState, useEffect } from 'react';
import "./CadastrarUsuario.css";
import { Form, Input, Button, Select, message } from 'antd';
import { UserOutlined, PhoneOutlined, MailOutlined, HomeOutlined, LockOutlined } from '@ant-design/icons';
import api from '../../../../services/api';
import API_CONFIG from '../../../../config/api.config';

const { Option } = Select;

const initialState = {
  nome: '',
  telefone: '',
  email: '',
  cep: '',
  logradouro: '',
  numero: '',
  bairro: '',
  cidade: '',
  estado: '',
  tipoUsuario: '',
  fornecedor: '',
  prefeitura: '',
  login: '',
  senha: '',
};

const CadastrarUsuario = () => {
  const [form, setForm] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [isMenuExpanded, setIsMenuExpanded] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const handleMenuChange = (event) => {
      setIsMenuExpanded(!event.detail.isCollapsed);
    };
    window.addEventListener('menuStateChange', handleMenuChange);
    return () => window.removeEventListener('menuStateChange', handleMenuChange);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    let formattedValue = value;

    if (name === 'telefone') {
      formattedValue = formatarTelefone(value);
    }

    setForm(prevForm => ({ ...prevForm, [name]: formattedValue }));
    setTouched(prevTouched => ({ ...prevTouched, [name]: true }));
  };

  const formatarTelefone = (valor) => {
    if (!valor) return '';
    const numbers = valor.replace(/\D/g, '');
    if (numbers.length <= 11) {
      if (numbers.length <= 2) {
        return numbers;
      } else if (numbers.length <= 6) {
        return `(${numbers.slice(0, 2)}) ${numbers.slice(2)}`;
      } else if (numbers.length <= 10) {
        return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 6)}-${numbers.slice(6)}`;
      } else {
        return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 7)}-${numbers.slice(7, 11)}`;
      }
    }
    return valor;
  };

  const validate = () => {
    const newErrors = {};
    if (!form.nome?.trim()) newErrors.nome = 'Campo obrigatório';
    if (!form.telefone?.trim()) newErrors.telefone = 'Campo obrigatório';
    if (!form.tipoUsuario?.trim()) newErrors.tipoUsuario = 'Campo obrigatório';
    if (!form.login?.trim()) newErrors.login = 'Campo obrigatório';
    if (!form.senha?.trim()) newErrors.senha = 'Campo obrigatório';
    else if (form.senha.length < 1) newErrors.senha = 'Mínimo um caracteres';
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(true);
    const validationErrors = validate();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      try {
        setLoading(true);
        
        // Preparar payload no formato da API
        const payload = {
          USU_NOME: form.nome?.trim(),
          USU_TIPO: form.tipoUsuario,
          USU_LOGIN: form.login?.trim(),
          USU_TELEFONE: form.telefone?.replace(/\D/g, '') || '',
          USU_SENHA: form.senha?.trim()
        };

        const response = await api.post(API_CONFIG.ENDPOINTS.USUARIOS.CADASTRAR, payload);

        if (response.data.status) {
          message.success(response.data.message || 'Usuário cadastrado com sucesso!');
          setForm(initialState);
          setTouched({});
          setSubmitted(false);
        } else {
          message.error(response.data.message || 'Erro ao cadastrar usuário');
        }
      } catch (error) {
        //console.error('Erro ao cadastrar usuário:', error);
        if (error.response?.status === 401) {
          message.error('Sessão expirada. Por favor, faça login novamente.');
        } else if (error.response?.status === 422) {
          message.error(error.response.data.message || 'Dados inválidos. Verifique os campos preenchidos.');
        } else {
          message.error(error.response?.data?.message || 'Erro ao cadastrar usuário');
        }
      } finally {
        setLoading(false);
      }
    }
  };

  const showError = (field) => {
    return (submitted || touched[field]) && errors[field];
  };

  return (
    <div className={`home-container ${isMenuExpanded ? 'menu-expanded' : ''}`}>
      <div className="modal-wrapper">
        <h1 className="modal-title">Cadastrar Usuário</h1>
        <div className="modal-content">
          <form className="form-usuario" onSubmit={handleSubmit} autoComplete="off">
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Nome <span className="asterisco-obrigatorio">*</span></label>
                <input
                  type="text"
                  name="nome"
                  placeholder="Nome completo"
                  value={form.nome || ''}
                  onChange={handleChange}
                  className={showError('nome') ? 'erro' : ''}
                />
                {showError('nome') && <span className="msg-erro">{errors.nome}</span>}
              </div>
              <div className="form-group">
                <label className="form-label">Telefone <span className="asterisco-obrigatorio">*</span></label>
                <input
                  type="text"
                  name="telefone"
                  placeholder="(00) 00000-0000"
                  value={form.telefone || ''}
                  onChange={handleChange}
                  className={showError('telefone') ? 'erro' : ''}
                  maxLength="15"
                />
                {showError('telefone') && <span className="msg-erro">{errors.telefone}</span>}
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Tipo de Usuário <span className="asterisco-obrigatorio">*</span></label>
                <select
                  name="tipoUsuario"
                  value={form.tipoUsuario || ''}
                  onChange={handleChange}
                  className={`${showError('tipoUsuario') ? 'erro' : ''} input-menor`}
                >
                  <option value="">Selecione o Tipo</option>
                  <option value="ADM">Administrador</option>
                  <option value="PREFEITURA">Prefeitura</option>
                  <option value="FORNECEDOR">Fornecedor</option>
                </select>
                {showError('tipoUsuario') && <span className="msg-erro">{errors.tipoUsuario}</span>}
              </div>
            </div>

            <label className="form-label">Dados de Acesso:</label>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Login <span className="asterisco-obrigatorio">*</span></label>
                <input
                  type="text"
                  name="login"
                  placeholder="Login"
                  value={form.login || ''}
                  onChange={handleChange}
                  className={showError('login') ? 'erro' : ''}
                />
                {showError('login') && <span className="msg-erro">{errors.login}</span>}
              </div>
              <div className="form-group">
                <label className="form-label">Senha <span className="asterisco-obrigatorio">*</span></label>
                <div className="password-input-container">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="senha"
                    placeholder="Senha"
                    value={form.senha || ''}
                    onChange={handleChange}
                    className={showError('senha') ? 'erro' : ''}
                  />
                  <button
                    type="button"
                    className="toggle-password"
                    onClick={() => setShowPassword(!showPassword)}
                    title={showPassword ? "Ocultar senha" : "Mostrar senha"}
                  >
                    {showPassword ? "👁️" : "👁️‍🗨️"}
                  </button>
                </div>
                {showError('senha') && <span className="msg-erro">{errors.senha}</span>}
              </div>
            </div>

            <div className="form-actions">
              <button 
                type="submit" 
                className="cadastro-submit-button"
                disabled={loading}
              >
                {loading ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CadastrarUsuario;